/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useRef } from "react";
import SignaturePad from "react-signature-canvas";
import { Button } from "../button";
import { PEN_COLOUR } from "../../service/forms/constants";

interface SignatureCanvasProps {
  text: string;
}

export const SignatureCanvas: React.FunctionComponent<SignatureCanvasProps> = ({
  text,
}: SignatureCanvasProps) => {
  const signCanvas = useRef() as React.MutableRefObject<any>;
  const clear = () => signCanvas.current.clear();
  const ma = "rgba(255,255,255,1)";

  return (
    <>
      <p>{text}</p>
      <SignaturePad
        backgroundColor={ma}
        ref={signCanvas}
        penColor={PEN_COLOUR}
        canvasProps={{
          className: "signatureCanvas signature-pad",
        }}
      />
      <div className="signature-button">
        <Button data-testid="btn-clear-sign" variant="tertiary" onClick={clear}>
          Clear
        </Button>
      </div>
    </>
  );
};
